export const noosIconText = $localize`:Product card|noos text@@noosText:NOOS`;
export const newIconText = $localize`:Product card|new label text@@newLabelText:NEW`;
export const genderMenText = $localize`:Pulse|gender icon tooltip@@genderTooltipIconMens:Men`;
export const genderWomenText = $localize`:Pulse|gender icon tooltip@@genderTooltipIconWomens:Women`;
export const genderUnisexText = $localize`:Pulse|gender icon tooltip@@genderTooltipIconUnisex:Unisex`;

import { IProductIconNames } from '@epicuro-next/models/products';

export const productIconsLabels: {
  [key in IProductIconNames]: (value?: unknown[]) => string;
} = {
  [IProductIconNames.Popularity]: () =>
    $localize`:Product card|Text for popularity label@@popularityBadgeLabel:Popular`,
  [IProductIconNames.Bestseller]: () =>
    $localize`:Product card|Text for bestseller label@@bestsellerBadgeLabel:Bestseller`,
  [IProductIconNames.Blackfriday]: () =>
    $localize`:Product card|Text for black friday label@@blackFridayBadgeLabel:Black Friday`,
  [IProductIconNames.Discount]: ([discount]: (string | number)[]) =>
    $localize`:Pulse|product discount up to label@@productDiscountUpToLabel:Up to -${discount}%`,
  [IProductIconNames.Stock]: () =>
    $localize`:Product card|Text for stock label@@stockBadgeLabel:Low on stock`,
  [IProductIconNames.Curation]: () =>
    $localize`:Product card|Text for curation label@@curationBadgeLabel:Popular`,
  [IProductIconNames.Promotion]: () =>
    $localize`:Product card|Text for promotion label@@promotionBadgeLabel:Promotion`,
  [IProductIconNames.isNew]: () => newIconText,
  [IProductIconNames.Trending]: () =>
    $localize`:Product card|Text for trending label@@trendingBadgeLabel:Trending`,
  [IProductIconNames.GenderMens]: () => genderMenText,
  [IProductIconNames.GenderWomens]: () => genderWomenText,
  [IProductIconNames.GenderUnisex]: () => genderUnisexText,
};

export const productIconsTooltipLabels: Partial<{
  [key in IProductIconNames]: string;
}> = {
  [IProductIconNames.Popularity]: $localize`:Config Strip|Tooltip for popularity icon@@popularTooltip:This product is in high demand`,
};
